import Sidebar from '@@/core/components/shared/Sidebar/Sidebar'
import Footer from '@@/core/components/shared/Footer/Footer'
import Header from '@@/core/components/shared/Header/Header'
import Notifications from '@@/core/components/shared/Notifications/Notifications'
import mixins from '@@/core/mixins/mixins'
import adminAssets from '@@/core/mixins/adminAssets'
 

export default {
  name: "Index",
  components: {
    Sidebar,
    Footer,
    Header,
    Notifications,
  },    
  mixins: [ mixins, adminAssets],
  data() {
    return {
      password: null,
      confirmPassword: null,
      oldPassword: null,
    }
  },
  created() {


  },
  mounted() {
    this.$store.dispatch('admin/loadInitData')
  },
  methods: {
    async changePassword() {
      this.disabled = true
      try{
        const response = await this.$axios.put('/admin/password' , {
          old_password: this.oldPassword,
          password: this.password,
          password_confirmation: this.confirmPassword,
        })
        this.$root.notify(response.data.messsage, 'success')
      } catch(error) {
        this.$root.notify(error)
      }
      this.disabled = false
    },
    sidebarStatus() {
      return this.$root.getCookie('sidebarStatus') == 'close' ? 'sidenav-toggled' : '';
    }
  }
}
